import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            精彩视频
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            幕后花絮、独家专访、精彩预告，51影院带你深入影视世界
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((media) => (
            <article
              key={media.title}
              className="group rounded-2xl bg-background-50 border border-background-200 overflow-hidden cursor-pointer hover:-translate-y-1 transition-all duration-300"
            >
              <div className="relative overflow-hidden aspect-video">
                <img
                  src={media.image}
                  alt={media.title}
                  title={`51影院 - ${media.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 text-xl md:text-2xl group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill"></i>
                  </span>
                </div>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 rounded-md text-xs font-medium bg-black/60 text-white whitespace-nowrap">
                  {media.duration}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-800 line-clamp-2 leading-relaxed">
                  {media.title}
                </h3>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}